/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Step_VerifyInputs */

const vi_care_log_step_verify = /** @type {(inputs: Care_Log_Step_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác minh`)
};

/**

* @param {Care_Log_Step_VerifyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_step_verify = /** @type {((inputs?: Care_Log_Step_VerifyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Step_VerifyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_step_verify(inputs)
});